import { BottomSheetTextInput } from "@gorhom/bottom-sheet";
import { Platform, TextInput } from "react-native";

/** Web-safe replacement for BottomSheetTextInput (gorhom blur/focus crashes on web). */
export const SheetTextInput =
  Platform.OS === "web" ? TextInput : BottomSheetTextInput;
